module.exports = __webpack_public_path__ + "static/media/language-learning.d736e536.png";